import { createContext } from 'react';
import { IGameCategories } from 'types';

export type TGameCategoriesSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TGameCategoriesCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	sortBy: TGameCategoriesSortBy;
	countOfItems: TGameCategoriesCountOfItems;
	currentPage: number;
}

export interface IGameCategoriesState {
	gameCategories: IGameCategories;
	searchString: string;
	sortBy: TGameCategoriesSortBy;
	countOfItems: TGameCategoriesCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const gameCategoriesInitialState: IGameCategoriesState = {
	gameCategories: { gameCategoriesCount: 0, gameCategories: [] },
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface IGameCategoriesContext extends IGameCategoriesState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TGameCategoriesSortBy): void;
	setCountOfItems(count: TGameCategoriesCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const GameCategoriesContext = createContext<IGameCategoriesContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...gameCategoriesInitialState,
});
